// extracted by mini-css-extract-plugin
export var details = "_l2-0";
export var inspectorPopover = "_l2-1";